import { render, staticRenderFns } from "./sub-list.vue?vue&type=template&id=5b273abd"
import script from "./sub-list.vue?vue&type=script&lang=js"
export * from "./sub-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports